import createIcon from '../../createIcon';

/**
 * @component @name FormatBold
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuMjI1IDExLjc5QzE2LjE5NSAxMS4xMiAxNi44NzUgMTAuMDIgMTYuODc1IDlDMTYuODc1IDYuNzQgMTUuMTI1IDUgMTIuODc1IDVINi42MjVWMTlIMTMuNjY1QzE1Ljc1NSAxOSAxNy4zNzUgMTcuMyAxNy4zNzUgMTUuMjFDMTcuMzc1IDEzLjY5IDE2LjUxNSAxMi4zOSAxNS4yMjUgMTEuNzlaTTkuNjI1IDcuNUgxMi42MjVDMTMuNDU1IDcuNSAxNC4xMjUgOC4xNyAxNC4xMjUgOUMxNC4xMjUgOS44MyAxMy40NTUgMTAuNSAxMi42MjUgMTAuNUg5LjYyNVY3LjVaTTEzLjEyNSAxNi41SDkuNjI1VjEzLjVIMTMuMTI1QzEzLjk1NSAxMy41IDE0LjYyNSAxNC4xNyAxNC42MjUgMTVDMTQuNjI1IDE1LjgzIDEzLjk1NSAxNi41IDEzLjEyNSAxNi41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatBold = createIcon('FormatBold', [
  [
    'path',
    {
      d: 'M15.225 11.79C16.195 11.12 16.875 10.02 16.875 9C16.875 6.74 15.125 5 12.875 5H6.625V19H13.665C15.755 19 17.375 17.3 17.375 15.21C17.375 13.69 16.515 12.39 15.225 11.79ZM9.625 7.5H12.625C13.455 7.5 14.125 8.17 14.125 9C14.125 9.83 13.455 10.5 12.625 10.5H9.625V7.5ZM13.125 16.5H9.625V13.5H13.125C13.955 13.5 14.625 14.17 14.625 15C14.625 15.83 13.955 16.5 13.125 16.5Z',
      key: '10o0cl',
    },
  ],
]);

export default FormatBold;
